import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    minHeight: '100vh',
    backgroundColor: '#F4F4F4',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 0',
    boxSizing: 'border-box',
  },

  toolbar: {
    width: '210mm',
    maxWidth: '90%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },

  downloadButton: {
    textTransform: 'none',
    fontWeight: 600,
  },

  /** === CONTENU PDF === */
  page: {
    // Largeur/hauteur en pixels pour un A4 210mm x 297mm à ~150 DPI
    // 210mm ≈ 8.27in → 8.27 * 150 ≈ 1240px
    // 297mm ≈ 11.69in → 11.69 * 150 ≈ 1754px
    width: '1240px',
    minHeight: '1754px',
    margin: '0 auto',
    padding: 0,
    boxSizing: 'border-box',
    background: '#FFFFFF',
    color: '#000000',
    fontFamily: 'Poppins',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 45px rgba(0, 0, 0, 0.12)',
    position: 'relative',
    // Propriétés pour améliorer la gestion des sauts de page
    pageBreakInside: 'auto',
    breakInside: 'auto',
    overflow: 'visible', // Permet au header de sortir si nécessaire
  },

  /** TITRES */
  heading: {
    fontFamily: 'Poppins',
    lineHeight: 1.3,
    fontWeight: 700,
    margin: '24px 0 12px',
    marginTop: '32px',
    color: '#000A8C !important',
    // Évite que le titre soit coupé et qu'il reste seul en bas de page
    pageBreakInside: 'avoid',
    pageBreakAfter: 'avoid',
    breakInside: 'avoid',
    breakAfter: 'avoid',
    // Si le titre est trop proche du bas, le déplacer à la page suivante
    orphans: 2,
    widows: 2,
  },

  /** PARAGRAPHES */
  paragraph: {
    fontSize: '20px',
    lineHeight: 1.6,
    margin: '0 0 12px 0',
    textAlign: 'justify',
    // Évite les lignes orphelines (seules en bas ou en haut de page)
    orphans: 2,
    widows: 2,
    // Permet les sauts de page à l'intérieur du paragraphe si nécessaire
    pageBreakInside: 'avoid',
    breakInside: 'avoid',
    fontFamily: 'Poppins',
  },

  /** IMAGES */
  imgPDF: {
    width: '60%',
    height: 'auto',
    objectFit: 'cover',
    objectPosition: 'center',
    margin: '20px auto',
    display: 'block',
    // Évite que l'image soit coupée entre deux pages
    pageBreakInside: 'avoid',
    pageBreakBefore: 'auto',
    pageBreakAfter: 'auto',
    breakInside: 'avoid',
  },

  header: {
    background:
      'transparent linear-gradient(106deg, #000A8C 0%, #E63C3C 47%, #FFDC37 100%) 0% 0% no-repeat padding-box',
    width: '100%', // Prend toute la largeur du conteneur parent (210mm)
    height: 300,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 80,
    paddingRight: 80, // Pas de padding pour coller aux bords
    margin: 0,
    // Pour être en full width et coller aux bords
    position: 'relative',
    boxSizing: 'border-box',
  },

  titleHeader: {
    fontSize: 48,
    color: 'white',
    textTransform: 'none',
  },
  imgBanner: {
    width: 1073,
    height: 900,
    display: 'block',
    margin: '0 auto 45px auto',
    background: '#000A8C',
    borderRadius: '8px',
    // Évite que la bannière soit coupée
    pageBreakInside: 'avoid',
    pageBreakBefore: 'auto',
    pageBreakAfter: 'auto',
    breakInside: 'avoid',
    position: 'relative',
    '& img': {
      width: '85%',
      height: 'auto',
      objectFit: 'cover',
      objectPosition: 'center',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },

  /** === SECTIONS POUR MIEUX GÉRER LES SAUTS DE PAGE === */
  section: {
    // Regroupe le contenu pour éviter les sauts de page inutiles
    // pageBreakInside: 'auto',
    // breakInside: 'auto',
    // marginBottom: '16px',
    // // Évite qu'une section soit coupée si elle est trop petite
    // minHeight: '50px',
  },
  info: {
    width: 'calc(100% - 30px)',
    padding: '20px 15px',
    background: 'white',
    borderRadius: '10px',
    border: '1px solid #E0E0E0',
  },
  infoContent: {
    fontFamily: 'Poppins',
    fontSize: '24px',
    lineHeight: '1.6',
    color: '#151528',
    '& span': {
      fontFamily: 'Poppins',
      fontWeight: 700,
      color: '#000A8C',
    },
  },
  sliderScore: {
    width: '100%',
    height: 'auto',
    background: 'white',
    borderRadius: '10px',
    border: '1px solid #E0E0E0',
    margin: '40px 0px',
    padding: '40px 0px 20px',
  },
  sliderScoreItem: {
    width: '80%',
    height: 'auto',
    margin: '0 auto',
    display: 'block',
  },
  score: {
    width: 'calc(100% - 30px)',
    border: '2px solid #000A8C',
    borderRadius: '10px',
    padding: '10px',
    background: 'white',
    fontSize: '28px',
    fontFamily: 'Poppins',
    fontWeight: 700,
    color: '#000A8C',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 50,
    '& span': {
      fontFamily: 'Poppins',
      fontSize: '48px',
      marginLeft: '10px',
    },
    '& span:last-child': {
      fontFamily: 'Poppins',
      fontSize: '32px',
      marginLeft: '2px',
    },
  },
  /** === GESTION DES SAUTS DE PAGE === */
  '@media print': {
    '.page-break-before': {
      pageBreakBefore: 'always',
      breakBefore: 'page',
    },
    '.page-break-after': {
      pageBreakAfter: 'always',
      breakAfter: 'page',
    },
    '.avoid-page-break': {
      pageBreakInside: 'avoid',
      breakInside: 'avoid',
    },
    // Améliore l'espacement pour éviter les sauts de page inutiles
    'h2, h3': {
      pageBreakAfter: 'avoid',
      breakAfter: 'avoid',
    },
  },
  h1: {
    fontSize: 70,
    fontWeight: 800,
  },
  h2: {
    fontSize: 58,
    fontWeight: 800,
  },
  h3: {
    fontSize: 50,
    fontWeight: 800,
  },
  h4: {
    fontSize: 42,
    fontWeight: 800,
  },
  h5: {
    fontSize: 34,
    fontWeight: 800,
  },
  h6: {
    fontSize: 30,
    fontWeight: 800,
  },
  imgWhiteBanner: {
    width: '50%',
    height: 'auto',
    display: 'block',
    margin: '50px auto 80px auto',
    background: 'white',
    borderRadius: '8px',
    // Évite que la bannière soit coupée
    pageBreakInside: 'avoid',
    pageBreakBefore: 'auto',
    pageBreakAfter: 'auto',
    breakInside: 'avoid',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
      objectPosition: 'center',
    },
  },
  listUl: {
    listStyle: 'none',
    padding: 0,
    paddingLeft: '1em',
    // Permet la pagination naturelle de la liste
    pageBreakInside: 'auto',
    breakInside: 'auto',
    // Évite que la liste entière saute à une nouvelle page
    pageBreakBefore: 'auto',
    breakBefore: 'auto',
  },
  listLi: {
    display: 'flex',
    padding: 0,
    color: '#151528',
    fontFamily: 'Poppins',
    fontSize: '20px',
    lineHeight: '36px',
    marginBottom: 7,
    marginLeft: '15px',
    // Permet la pagination naturelle des éléments de liste
    // Les éléments peuvent être répartis sur plusieurs pages
    pageBreakInside: 'avoid',
    pageBreakAfter: 'avoid',
    breakInside: 'avoid',
    breakAfter: 'avoid',
    // Évite qu'un élément soit coupé de manière inappropriée
    orphans: 2,
    widows: 2,
    '&::before': {
      content: '"\\2022"',
      color: '#151528',
      fontWeight: 'bold',
      display: 'inline-block',
      marginRight: 8,
      fontSize: '32px',
      marginLeft: 'calc(-1em + 2px);',
      top: -2,
      position: 'relative',
    },
    '& p': {
      fontSize: '20px',
    },
  },
  imgPyramidContainer: {
    transform: 'scale(1.1)',
    overflow: 'hidden',
    width: '100%',
  },
  imgPyramid: {
    width: '100%',
    objectFit: 'cover',
  },
}));

export default useStyles;
